interface QuotaLimitBannerProps {
  title: string;
  body?: string | null;
  className?: string;
}

export const QuotaLimitBanner = ({ title, body, className }: QuotaLimitBannerProps) => (
  <div className={`tcw-limit-reached-box${className ? ` ${className}` : ""}`}>
    <span className="tcw-limit-reached-box__icon" aria-hidden="true">
      <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
        <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="currentColor" />
      </svg>
    </span>
    <div className="tcw-limit-reached-box__text">
      <p className="tcw-limit-reached-box__title">{title}</p>
      {body && <p className="tcw-limit-reached-box__body">{body}</p>}
    </div>
  </div>
);
